import PropTypes from "prop-types";
import { Text } from "@/components/customComponents";
import { Icon, IconVariants, IconSize } from "@next-platform/client-common-spicy-ui";

const CharacterRatingScore = ({ rating_score }) => {
  if (!rating_score || rating_score < 0.01) return null;
  return (
    <>
      <span className="mr-2 text-[10px] align-middle flex items-center">
        <Icon icon={IconVariants.LIKE} size={IconSize.XSMALL} className="mr-1" />
        <Text variant={"xxs"}>{Math.round(rating_score * 100, 0)}%</Text>
      </span>
    </>
  );
};
CharacterRatingScore.propTypes = {
  rating_score: PropTypes.number,
};

export default CharacterRatingScore;
